<template>
    <admin-breadcrumbs>
         <li class="breadcrumb-item">
            <router-link to="/admin/languages/">
                Languages
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Edit Language
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Edit Language
        </div>

        <div class="card-body">
           <language-edit-form
               :endpoint="`/admin/api/languages/${$route.params.id}`"
               method="put"
           />
        </div>

    </div>
</template>

<script>
import LanguageEditForm from "../../../admin/LanguageEditForm.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
  name: "LanguageEdit",

  components: {
      AdminBreadcrumbs,
    LanguageEditForm,
  },
};
</script>
